<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <form @submit.prevent="save">
      <header class="text-center pb-4 border-b border-grey">
        <h3
          class="my-0 font-bold"
          v-text="'Create a new folder'"
        />
      </header>
      <div class="mt-4">
        <div>
          <input
            id="folder-title"
            v-model="form.title"
            class="input"
            :class="{ 'error': form.errors.has('title') }"
            placeholder="Title"
            type="text"
            name="folder-title"
          >
          <span
            v-if="form.errors.has('title')"
            class="field__meta__help"
            v-text="form.errors.get('title')"
          />
        </div>
      </div>
      <div class="modal-footer text-center mt-4">
        <button
          :class="{ 'load': isLoading }"
          class="btn"
          type="submit"
          v-text="'Save'"
        />
        <a
          class="ml-4"
          href="#"
          @click.prevent="close"
          v-text="'Cancel'"
        />
      </div>
    </form>
  </BaseModal>
</template>

<script type="text/babel">
import Form from 'Base/Resources/assets/js/plugins/Form'

export default {
  name: 'CreateFolderModal',
  props: {
    parentFolderUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      form: new Form({
        title: '',
      }),
      folders: [],
    }
  },
  computed: {
    show() {
      return this.$store.state.document.createFolderModal.open
    },
  },
  methods: {
    save() {
      this.isLoading = true

      this.$api.active().post('folders', {
        title: this.form.title,
        parentFolderUuid: this.parentFolderUuid,
      }).then(() => {
        this.$emit('documentFolderHasBeenCreated')

        this.parentFolderUuid
          ? this.$store.dispatch('documentGetFolderDetails', this.parentFolderUuid)
          : this.$store.dispatch('documentGetFolderTree')

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: 'Folder created!',
        })

        this.close()
      }).catch((errors) => {
        this.form.setErrors(errors.response.data)

        this.$store.commit('baseAddNotification', {
          type: 'error',
          title: 'Error',
          text: errors.response.data.message,
        })
      }).finally(() => { this.isLoading = false })
    },
    close() {
      this.form.title = ''

      this.$store.commit('documentCloseCreateFolderModal')
    },
  },
}
</script>
